import {
  IonAccordionGroup,
  IonCol,
  IonLoading,
  IonRow,
  IonText,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { makeGETRequest } from "../../request/rawRequest";
import { Comp } from "../../types/comp";
import {
  getCurrentTechno,
  getCurrentTechnoOrDisconnect,
} from "../../variables/jobDictionnary";
import BasicPage from "../BasicPage/BasicPage";
import "../IonColor/color.css";
import AccordionItem from "../List/AccordionList";
import "../generalCSS/stylesheet.css";
import "./Competence.css";

interface ContainerProps {}

const competences = async (): Promise<Comp[]> => {
  const competences: Comp[] = [];

  await makeGETRequest(
    "/skills/technology/unique?type=" +
      getCurrentTechnoOrDisconnect() +
      "&pole=" +
      localStorage.getItem("pole"),
  ).then(async (response) => {
    for (let i: number = 0; i < response.length; i++) {
      competences.push({
        id: response[i]._id,
        name: response[i].name,
        themesID: Object.is(response[i].id_themes, [""])
          ? null
          : response[i].id_themes,
        index: response[i].index,
        themes: [],
      });
    }
  });

  return competences.sort((a: any, b: any) => a?.index - b?.index);
};

const getTitle = (): string => {
  switch (getCurrentTechno()) {
    case "boul":
      return "Savoirs associés";
    case "prim":
      if (localStorage.getItem("pole") === "1") {
        return "Pratique - Boutique";
      } else return "Pratique - Fraîche Découpe";
    case "char":
      return "Les Fabrications";
    default:
      return "Technologie - Pôle " + localStorage.getItem("pole");
  }
};

const Competence: React.FC<ContainerProps> = () => {
  const [compList, setCompList] = useState<Comp[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const comptemp: Promise<Comp[]> = competences();

  useEffect(() => {
    comptemp.then((response) => {
      response.map((arr, i) => {
        if (arr.name === "S1" || arr.name === "S2" || arr.name === "S3") {
          arr.themes.reverse();
        }
      });

      if (response[0].name.split("-")[0].replaceAll(" ", "").length === 3)
        response.sort((a, b) =>
          a.name
            .split("-")[0]
            .replaceAll(" ", "")
            .localeCompare(b.name.split("-")[0].replaceAll(" ", "")),
        );

      setCompList(response);
    });
  }, []);

  useEffect(() => {
    if (compList.length > 0) setIsLoading(false);
  }, [compList]);

  return (
    <>
      <BasicPage pathReturn title={getTitle()}>
        <IonLoading isOpen={isLoading} cssClass="loading" />
        <IonAccordionGroup>
          {compList.map((comp, i) => (
            <AccordionItem
              key={i}
              name={
                <IonText color="black" className="margin-15">
                  <span className="bold primary-contrast-text">
                    {comp.name.toLocaleUpperCase().split("(")[0]}
                  </span>
                  <span className="no-bold desc-comp">
                    {comp.name.toLocaleLowerCase().split("(")[1]
                      ? "(" + comp.name.toLocaleLowerCase().split("(")[1]
                      : ""}
                  </span>
                </IonText>
              }
              themesID={comp.themesID}
              compID={comp.id}
            />
          ))}
        </IonAccordionGroup>

        <IonRow className="ion-align-items-center">
          <IonCol
            hidden={
              !(getCurrentTechnoOrDisconnect() === "pat") &&
              !(getCurrentTechnoOrDisconnect() === "prim") &&
              !(getCurrentTechnoOrDisconnect() === "cuis")
            }
            className="ion-justify-content-end flex"
            onClick={() => {
              localStorage.setItem(
                "pole",
                localStorage.getItem("pole") === "1" ? "2" : "1",
              );
              window.location.reload();
            }}
          >
            <span className="btn fit-content padding ion-align-items-center">
              {getCurrentTechnoOrDisconnect() === "boul"
                ? "Savoirs associés"
                : getCurrentTechnoOrDisconnect() === "prim"
                  ? "Pratique - " +
                    (localStorage.getItem("pole") === "1" ? 2 : 1)
                  : "Technologie - Pôle " +
                    (localStorage.getItem("pole") === "1" ? 2 : 1)}
            </span>
          </IonCol>
        </IonRow>
      </BasicPage>
    </>
  );
};

export default Competence;
